import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import Root from "./routes/Root";
import Error from "./routes/Error";
import ComingSoon from "./routes/ComingSoon";
import Admin from "./routes/Admin";
import Dashboard from "./routes/Dashboard";
import Cron from "./routes/Cron";
import Status from "./routes/Status";
import ExpiredDocs from "./routes/ExpiredDocs";
import PaymentsConfig from "./routes/CountryPaymentsConfig";
import CraftCabinetPrivacy from "./routes/CraftCabinetPrivacy";

import reportWebVitals from "./reportWebVitals";

import { createBrowserRouter, RouterProvider } from "react-router-dom";
import AuthRequired from "./features/auth/AuthRequired";
import LoginPage from "./routes/LoginPage";
import "./index.css";
import 'bootstrap/dist/css/bootstrap.css';
import { GoogleOAuthProvider } from '@react-oauth/google';



// Front-end routes
const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <Error />,
    children: [
      {
        index: true,
        element: <ComingSoon />,
      },
      {
        path: "login",
        element: <LoginPage />,
      },
      {
        element: <AuthRequired />,
        children: [
          {
            path: "admin",
            element: <Admin />,
          },
          {
            path: "cron",
            element: <Cron />,
          },
          {
            path: "dashboard",
            element: <Dashboard />,
          },
          {
            path: "status", 
            element: <Status />,
          },
          {
            path: "expired_docs", 
            element: <ExpiredDocs />,
          },
          {
            path: "payments-config",
            element: <PaymentsConfig />
          }
        ],
      },
    ],
  },
  {
    // Public, standalone page - no auth wrapper, no sidebar.
    path: "/craft-cabinet",
    element: <CraftCabinetPrivacy />,
    errorElement: <Error />,
  },
]);

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <GoogleOAuthProvider clientId="591957379563-h3dorir9djl3on7tec380r5ocg8m99dp.apps.googleusercontent.com">
    <React.StrictMode>
      <Provider store={store}>
        <RouterProvider router={router} />
      </Provider>
    </React.StrictMode>
  </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
